import { api } from './index';
import { omitBy } from 'lodash';
import { isNil } from 'utils';

export default {
  getKeywordList({ q, cursor, limit }) {
    return api.get('/search_suggestions', {
      params: omitBy({ q, cursor, limit }, isNil),
    });
  },
  deleteKeyword(id) {
    return api.delete(`/search_suggestions/${id}`);
  },
  updateKeywordOrder(payload) {
    return api.put('/search_suggestions/update_order', payload);
  },
};
